import { withRouter } from 'react-router-dom';
import WithSystem from './../service/WithSystem';
const branchFilter = JSON.parse(window.branchFilter);
class BranchDropDown extends React.Component {
    constructor(props){
        super(props);
        this.box = React.createRef();
        this.state = {branchdropdownToggle:false};
      }

  setBranchItems = (selectedId,event) => {
    let branches = this.props.queryFilter.branches;
    branches = branches ? branches.split(',') : [];
    if(event.target.checked){
    branches = branches.length ? [...branches, selectedId] : [selectedId];
    }else{
      branches = branches.filter((branch) => {
        return (branch != selectedId);
      });
    }
    branches = branches.length?branches.join():false;
    this.props.setGlobalState({ branches });
  }
  SetBranchDropdownToggleVall = ()=>{
    this.setState({branchdropdownToggle:!this.state.branchdropdownToggle},()=>{
      document.addEventListener('click', this.handleOutsideClick);
    });
  }
  handleOutsideClick = (event) => {
    if (this.box && !this.box.current.contains(event.target)) {
      this.setState({branchdropdownToggle:!this.state.branchdropdownToggle},()=>{
        if (this.state.branchdropdownToggle == true) {
          this.setState({ branchdropdownToggle: false });
        }
        document.removeEventListener('click', this.handleOutsideClick);
      });
    }
  }
    render() {
      const branchesItems = this.props.queryFilter['branches'] ? this.props.queryFilter['branches'].split(',') : [];
      
      return (
          <div ref={this.box} onClick={() => this.SetBranchDropdownToggleVall()} className={this.state.branchdropdownToggle == true ? 'branch-list active' : 'branch-list'}>
            <span className="filter-subtxt">Branch</span>
            <div className="report-list-menu" >
              <div className="branch-list-sec">Select Branch</div>
              <div className="list_menu_section" >
                <ul className="list_menu">
                  { branchFilter.map((course) => {
                    let hasChecked = branchesItems.includes(course.id);
                    return <li key={`course_${course.id}`}>
                              <label htmlFor={`branch_${course.id}`}>
                              <span>
                                <input id={`branch_${course.id}`} onClick={(e) => this.setBranchItems(`${course.id}`,e)} className="bc_column_visible bc_initial_events uncheckbox" defaultChecked={hasChecked}  data-column-name="Attendee Name" type="checkbox" data-field-name="attendee_name" />
                                <span className="checkedmark"></span>
                              </span>
                              <span className="dropdownlist_singleline"> {course.ib_institute_code} - {course.ib_name}</span>
                              </label></li>;
                  })}
                </ul>
              </div>
            </div>
          </div>
          );
    }
}
export default withRouter(WithSystem(BranchDropDown));